import { render, staticRenderFns } from "./donut-card.vue?vue&type=template&id=7c2be72f&scoped=true"
import script from "./donut-card.vue?vue&type=script&lang=ts"
export * from "./donut-card.vue?vue&type=script&lang=ts"
import style0 from "./donut-card.vue?vue&type=style&index=0&id=7c2be72f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2be72f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2be72f')) {
      api.createRecord('7c2be72f', component.options)
    } else {
      api.reload('7c2be72f', component.options)
    }
    module.hot.accept("./donut-card.vue?vue&type=template&id=7c2be72f&scoped=true", function () {
      api.rerender('7c2be72f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/donut-card/donut-card.vue"
export default component.exports